// Import package
import React, { useEffect, useState } from "react";
import moment from "moment";
import FilterBarChartMonthlyParticipants from "../../../components/adminRole/dashboard/FilterBarChartMonthlyParticipants";
import DashboardBarChart from "../../../components/adminRole/dashboard/DashboardBarChart";
import { getDashboardTrainingParticipantYearlyGraph, getDashboardTrainingRegisterYearlyGraph } from "../../../appRedux/actions";
import FilterBarChartMonthlyRegister from "../../../components/adminRole/dashboard/FilterBarChartMonthlyRegister";
// Component
export default function BarChartYearlyRegister({ trainingOptions, locations }) {
  const [data, setData] = useState([])
  const [filter, setFilter] = useState({
    training_option_id: null,
    status: null,
    start_date: moment().startOf('year').subtract(10, 'years').toISOString(),
    end_date: moment().endOf('year').toISOString(),
    location: null,
    category_id: null,
  })

  useEffect(() => {
    getDashboardTrainingRegisterYearlyGraph(filter).then((rows) => {
      setData(rows.map((n) => {
        return {
          name: n.year,
          register: n.total,
        }
      }))
    })
  }, [filter])

  return (
    <>
      <FilterBarChartMonthlyRegister
        trainingOptions={trainingOptions}
        locations={locations}
        filter={filter}
        setFilter={setFilter}
        picker="year"
      />
      <DashboardBarChart
        barKey="register"
        fillColor="#ff7a45"
        data={data}
        barName="Pendaftar Tahunan"
      />
    </>
  );
}
